module.exports = __webpack_public_path__ + "static/img_2502_optimized-3567017bf194190e3df79bf48c0fa00d.jpg";